import { html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-label-data-heading.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The IDB Image Card component.
 * @element idb-content-card
 * @extends OutlineElement
 * @see Events Card for similar styling
 */

@customElement('idb-label-data-heading')
export class LabelAndDataHeading extends OutlineElement {
  static styles = [componentStyles];

  render(): TemplateResult {
    const cardClasses = {
      'idb-label-data-heading': true,
    };

    return html`
     <section class="${classMap(cardClasses)}">
      <div class="heading-label">
        <slot name="heading-label"></slot><span class="colon">:&nbsp;</span>
      </div>
      <div class="heading-data">
        <slot name="heading-data"></slot>
      </div>
     </section>
    `;
  }
}
